<template>
  <div>
    <h1>Articles</h1>
    <v-btn :to="{ name: 'articleAdd' }">Create</v-btn>
    <v-btn @click="calculatePercentageReturning()"
      >Calculate percentage returning</v-btn
    >
    <v-select
      label="Article type"
      v-model="articleType"
      :items="articleTypes"
      outline
    />
    <v-text-field
      v-model="filter"
      append-icon="search"
      @click:append="search"
      label="Search"
      single-line
      outline
      hide-details
    />
    <br />
    <v-data-table
      :pagination.sync="pagination"
      :total-items="articleCount"
      :loading="loading"
      :headers="headers"
      :items="articles"
      :footer-props="{ showFirstLastPage, showCurrentPage }"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr @click="navigate(props.item)">
          <td>{{ props.item.articleId }}</td>
          <td>{{ props.item.heading }}</td>
          <td style="word-wrap: break-word">{{ props.item.pageName }}</td>
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.created | formatDate }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Articles",
  metaInfo() {
    return {
      title: "Articles",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      articleCount: 0,
      articles: [],
      headers: [
        {
          text: "Id",
          value: "articleId"
        },
        {
          text: "Heading",
          value: "heading"
        },
        {
          text: "Page name",
          value: "pageName"
        },
        {
          text: "Meta title",
          value: "title"
        },
        {
          text: "Created",
          value: "created"
        }
      ],
      filter: "",
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 10
      },
      showFirstLastPage: true,
      showCurrentPage: true,
      articleTypes: [
        "ARTICLE",
        "BRANCH",
        "COUNTY",
        "OTHER",
        "POPULATION",
        "CORNERSTONE"
      ],
      articleType: "ARTICLE",
      percentageReturning: null
    };
  },
  methods: {
    async fetchArticleCount() {
      const response = await nbmlaw.get(
        `/cors/open/extras/articles/type/${this.articleType}/count`,
        {
          params: {
            filter: this.filter
          }
        }
      );
      // console.log(response.data)
      this.articleCount = response.data;
    },
    async fetchArticles() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      // console.log("sort by: " + sortBy + ", sort descending: " + descending);
      let firstRow = (page - 1) * rowsPerPage;
      // console.log("article type: " + this.articleType + ", firstRow: " + firstRow + ", rowsPerPage: " + rowsPerPage);
      const response = await nbmlaw.get(
        `/cors/open/extras/articles/type/${this.articleType}/${firstRow}/${rowsPerPage}`,
        {
          params: {
            sortBy,
            descending,
            filter: this.filter
          }
        }
      );
      // console.log(response.data)
      this.articles = response.data;
      this.loading = false;
    },
    async calculatePercentageReturning() {
      const response = await nbmlaw.get(
        `/cors/admin/extras/percentageReturning`
      );
      // console.log(response.data);
      this.percentageReturning = response.data;
    },
    update() {
      this.loading = true;
      this.fetchArticleCount();
      this.fetchArticles();
    },
    navigate(item) {
      // console.log(item.articleId);
      this.$router.push({
        name: "articleEdit",
        params: {
          id: item.articleId
        }
      });
    },
    search() {
      this.pagination.page = 1;
      this.update();
    }
  },
  watch: {
    pagination: {
      handler() {
        this.update();
      },
      deep: true
    },
    articleType: {
      handler() {
        this.pagination.page = 1;
        this.update();
      }
    }
  },
  created() {
    this.update();
  }
};
</script>
